module.exports = __webpack_public_path__ + "static/media/check-correct.7b41b547.svg";